export default __webpack_public_path__ + "static/media/germ_novice_badge_smaller@3x.ea5e544b.png";